export enum Flavor {
  Pflegia = 'pflegia',
  Praxia = 'praxia',
}
